import { render, staticRenderFns } from "./DistressImageList.vue?vue&type=template&id=afea0648"
import script from "./DistressImageList.vue?vue&type=script&lang=js"
export * from "./DistressImageList.vue?vue&type=script&lang=js"
import style0 from "./DistressImageList.vue?vue&type=style&index=0&id=afea0648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports